import { render, staticRenderFns } from "./appAccordion.vue?vue&type=template&id=6520d501"
import script from "./appAccordion.vue?vue&type=script&lang=js"
export * from "./appAccordion.vue?vue&type=script&lang=js"
import style0 from "./appAccordion.vue?vue&type=style&index=0&id=6520d501&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports